import React from "react";

export function TtlsChats(props) {
  return <h6 className="title ">{props.title}</h6>;
}
